@if (initialized) {
    <as-free-slot
            *ngIf="agent"
            [appointment]="appointment"
            [agents]="[agent]"
            [addressId]="addressId"
            [objectIdentifier]="objectIdentifier"
            [appointmentTypeId]="appointmentType?.id"
            [hideSelectionHeader]="true"
            [onlySelectedAgent]="!newAgent"
            [customerName]="name"
            (onAppointmentUpdate)="handleAppointmentUpdate($event)"
    ></as-free-slot>

}